<template>
  <div>
    <h2 class="mx-3 page-title">Add New Address</h2>
    <b-row class="form-row">
      <b-col cols="12">
        <b-card>
          <GmapAutocomplete
            @place_changed="placechange2"
            class="location-search w-100"
            placeholder="Enter location *"
            :options="{
              fields: ['geometry', 'formatted_address', 'address_components'],
            }"
          ></GmapAutocomplete
        ></b-card>
      </b-col>
    </b-row>
    <b-row class="form-row">
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <c-input
            class="w-100"
            inputType="text"
            inputId="userName"
            labelText="* Name"
            v-model="name"
        /></b-card>
      </b-col>
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider
            rules="required|email"
            v-slot="{ errors }"
            name="Email"
          >
            <c-input
              inputType="Email"
              inputId="email"
              labelText="* Email"
              v-model="email"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider></b-card
        >
      </b-col>
    </b-row>
    <b-row class="form-row">
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <label>* Mobile Number</label>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="phone number"
          >
            <c-tel-input inputType="number" v-model="number1" />
            <span class="validate-error validate-error-mobile">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <label>* Alternative Mobile Number</label>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="phone number"
          >
            <c-tel-input inputType="number" v-model="number2" />
            <span class="validate-error validate-error-mobile">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="form-row">
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="House No"
          >
            <c-input
              type="text"
              inputId="state"
              v-model="office.address.houseNumber"
              labelText="* Buidling Name/Numbers"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Country"
          >
            <c-input
              inputType="text"
              inputId="Country"
              labelText="* Country "
              v-model="office.address.country"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider></b-card
        >
      </b-col>
    </b-row>
    <b-row class="form-row">
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Address Line 1"
          >
            <c-input
              type="text"
              inputId="street1"
              v-model="office.address.street1"
              labelText="* Address Line 1"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Address Line 2"
          >
            <c-input
              type="text"
              inputId="street2"
              v-model="office.address.street2"
              labelText="* Address Line 2"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="form-row">
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider rules="required" v-slot="{ errors }" name="city">
            <c-input
              inputType="text"
              inputId="city"
              labelText="* District/City "
              v-model="office.address.city"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider rules="required" v-slot="{ errors }" name="state">
            <c-input
              type="text"
              inputId="state"
              v-model="office.address.state"
              labelText="State"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="form-row">
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <b-card>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="pincode"
          >
            <c-input
              type="text"
              inputId="pincode"
              v-model="office.address.zip"
              labelText="* Pincode"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-card>
      </b-col>
      <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
        <h4 class="address-type-title">Address Type *</h4>
        <b-form-group class="address-type-group">
          <b-form-radio-group
            id="radio-group-2"
            name="radio-sub-component"
            v-model="selectedRadio"
          >
            <b-form-radio value="HOME" name="radio-size" size="lg"
              ><h5 class="radio-align">Home</h5>
            </b-form-radio>
            <b-form-radio value="WORK" name="radio-size" size="lg">
              <h5 class="radio-align">Work</h5>
            </b-form-radio>
            <b-form-radio value="OTHERS" name="radio-size" size="lg">
              <h5 class="radio-align">Others</h5>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row align-h="center" class="mt-3 mb-5 action-buttons-row">
      <b-col cols="12" sm="6" md="4" lg="3" class="mb-2 mb-sm-0">
        <b-button variant="danger" class="w-100 cancel-btn"
          >CANCEL</b-button
        >
      </b-col>
      <b-col cols="12" sm="6" md="4" lg="3" class="mb-2 mb-sm-0">
        <b-button variant="primary" class="w-100 save-btn" @click="addNewAddress"
          >SAVE</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import locationMixins from "@/mixins/addressLocation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cTelInput from "@/components/Common/MobileNumberInput";
export default {
  mixins: [locationMixins],
  components: { cInput, cTelInput, ValidationProvider, ValidationObserver },
  data() {
    return {
      selectedRadio: "HOME",
      position: {
        lat: 0,
        lng: 0,
      },
      name: "",
      email: "",
      number1: "",
      number2: "",
      office: {
        address: {
          country: "",
          street1: "",
          street2: "",
          state: "",
          city: "",
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0],
          },
        },
      },
    };
  },
  methods: {
    async placechange2(e) {
      let place = await e;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.position = position;
      this.placechange(e);
      this.$emit("place_changed", e);
      let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
      if (mapdata) {
        this.office.address.country = mapdata.data.Country;
        this.office.address.city = mapdata.data.City;
        this.office.address.state = mapdata.data.State;
        this.office.address.street1 = mapdata.data.Area
          ? mapdata.data.Area
          : "";
        this.office.address.zip = mapdata.data.zip ? mapdata.data.zip : "";
        this.office.address.location = {
          coordinates: [mapdata.Lng, mapdata.Lat],
        };
      }
    },
    async addNewAddress() {
      const payload = {
        address: {
          fullName: this.name,
          houseNumber: this.office.address.houseNumber,
          street2: this.office.address.street2,
          street1: this.office.address.street1,
          zip: this.office.address.zip,
          city: this.office.address.city,
          state: this.office.address.state,
          country: this.office.address.country,
          category: this.selectedRadio,
          isDefault: false,
          location: this.office.address.location,
          contacts: [
            { value: this.number1, contactType: "PRIMARY_PHONE" },
            { value: this.email, contactType: "PRIMARY_EMAIL" },
          ],
        },
      };
      try {
        await this.$store
          .dispatch("customerManagement/createNewAddress", payload)
          .then(() => {
            this.$swal({
              title: "Success",
              text: "Address added successfully!!",
              type: "success",
            });
          });
        this.$router.push({ name: "Customer-Management-Listing" });
      } catch (err) {
        this.$swal({
          title: "Opps!!!!!",
          text: `${err}`,
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
.page-title {
    margin-bottom: 1rem;
}

.form-row {
    margin-bottom: 1rem;
}

.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: 'Lato';
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}

.validate-error {
    display: block;
    color: red;
    font-size: 12px;
    margin-top: 5px;
}

.validate-error-mobile {
    margin-left: 0;
    margin-top: 5px;
}

.address-type-title {
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
}

.address-type-group {
    margin-top: 0.5rem;
    margin-left: 0.75rem;
}

.radio-align {
    font-size: 20px;
    margin-left: 11px;
    margin-top: -2px;
}

.action-buttons-row {
    margin-top: 1.5rem;
    margin-bottom: 3rem;
}

.cancel-btn,
.save-btn {
    min-width: 120px;
}

@media (max-width: 767.98px) {
    .page-title {
        font-size: 1.5rem;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }

    .form-row {
        margin-bottom: 0.75rem;
    }

    .address-type-title {
        margin-left: 0;
        font-size: 1.25rem;
    }

    .address-type-group {
        margin-left: 0.5rem;
    }

    .radio-align {
        font-size: 18px;
        margin-left: 8px;
    }

    .cancel-btn,
    .save-btn {
        min-width: 100%;
    }

    .action-buttons-row {
        margin-bottom: 2rem;
    }
}

@media (max-width: 575.98px) {
    .page-title {
        font-size: 1.25rem;
    }

    .radio-align {
        font-size: 16px;
        margin-left: 6px;
    }
}
</style>
